import React from "react";

const AboutSection = () => {
  return (
    <div
      className="section-full site-bg-white p-t150 p-b120 twm-abus-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2s"
    >
      <div className="container">
        <div className="row twm-abus-section">

          {/* LEFT SIDE */}
          <div className="col-lg-7 col-md-12">
            <div className="twm-abus-left">

              <div className="twm-media">
                <img src="images/abus-pic.jpg" alt="Shivai Travels" />

                

                <div className="twm-abus-year-section">
                  <div className="tem-abus-year-content">
                    <span>Since</span>
                    <h2 className="year-title">2016</h2>
                  </div>
                </div>
              </div>

              <div className="twm-media2">
                <img src="/images/car.png" alt="Luxury Car" />
              </div>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-5 col-md-12">

            {/* TITLE START */}
            <div className="section-head left aside-section">
              <div className="twm-sm-title left">
                About Shivai Travels
              </div>

              <h2 className="twm-large-title site-text-dark">
                Reliable Cab Services For Local, Outstation & Corporate Travel
              </h2>

              <div className="section-head-detail">
                Shivai Travels is committed to providing safe, comfortable,
                and affordable travel experiences for individuals, families,
                and businesses. With a professional team of drivers and a
                well-maintained fleet of vehicles, we ensure smooth journeys
                for local rides, airport transfers, outstation trips, and
                corporate travel needs. Customer satisfaction, punctuality,
                and safety are at the heart of our service.
              </div>
            </div>
            {/* TITLE END */}

            {/* <div className="twm-inline-list2">
              <ul>
                <li>All Types Of Vehicles Available</li>
                <li>24/7 Cab Booking Support</li>
                <li>Professional & Experienced Drivers</li>
              </ul>
            </div>

            <div className="twm-btn-left">
              <a href="about-us" className="site-button">
                <em>Read More</em>
              </a>
            </div> */}

          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutSection;